<template>
  <div class="bg-gray-50 relative overflow-hidden" ref="centerRef">
    
    <div class="w-full h-full relative z-10">

      <!-- 我的客户 -->
       <!-- <div class="w-full bg-[#e3fce9] mb-16">
          <div class="max-w-7xl mx-auto p-6 sm:p-8 md:p-12">
            <h2 class="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 mb-4 sm:mb-6 text-center">
              {{ t('about.center.clients.title') }}
            </h2>
            <p class="text-gray-600 text-center mb-6 sm:mb-8 text-xs sm:text-sm max-w-4xl mx-auto px-4">
              {{ t('about.center.clients.description') }}
            </p>
            <div class="flex justify-center mb-6 sm:mb-8">
              <button @click="navigateToContact" class="bg-green-500 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-lg hover:bg-green-600 font-medium text-xs sm:text-sm">
                {{ t('about.center.clients.viewMore') }}
              </button>
            </div>

            <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6 md:gap-8 lg:gap-12 items-center">
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand1" alt="Brand 1" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand2" alt="Brand 2" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand3" alt="Brand 3" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand4" alt="Brand 4" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand5" alt="Brand 5" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand6" alt="Brand 6" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand7" alt="Brand 7" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand8" alt="Brand 8" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand9" alt="Brand 9" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
              <div class="flex justify-center p-3 sm:p-4 bg-white rounded-lg shadow-sm">
                <img :src="brand10" alt="Brand 10" class="w-16 h-12 sm:w-20 sm:h-14 md:w-24 md:h-16 object-contain" />
              </div>
            </div>
          </div>
       </div> -->
      

      <!-- 业务亮点 -->
      <div class="max-w-7xl mx-auto p-4 sm:p-6 mb-8">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <!-- 左侧简介 -->
          <div class="lg:col-span-3">
            <div class="p-4">
              <h3 class="text-sm sm:text-base font-bold mb-2 text-black">
                {{ t('about.center.services.title') }}
              </h3>
              <p class="text-gray-700 text-xs sm:text-sm leading-relaxed mb-4">
                {{ t('about.center.highlights.global') }}
              </p>
              <p class="text-gray-700 text-xs sm:text-sm leading-relaxed mb-4">
                {{ t('about.center.services.description') }}
              </p>
              <div class="mb-4">
                <div class="w-10 h-10 flex items-center justify-center mb-2">
                  <img :src="cooperationIcon" alt="合作共赢" class="w-full h-full">
                </div>
                <p class="text-gray-700 text-xs sm:text-sm leading-relaxed bg-[#e3fce9] rounded-lg p-4">
                  {{ t('about.center.services.equipment') }}
                </p>
              </div>
            </div>
          </div>
          <!-- 中间产品展示 -->
          <div class="lg:col-span-5">
            <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 gap-2 sm:gap-3">
              <div class="overflow-hidden rounded">
                <img
                  :src="product1"
                  alt="Product 1"
                  class="w-full h-32 sm:h-36 lg:h-40 object-fill"
                />
              </div>
              <div class="overflow-hidden rounded">
                <img
                  :src="product2"
                  alt="Product 2"
                  class="w-full h-32 sm:h-36 lg:h-40 object-fill"
                />
              </div>
              <div class="overflow-hidden rounded">
                <img
                  :src="product3"
                  alt="Product 3"
                  class="w-full h-32 sm:h-36 lg:h-40 object-fill"
                />
              </div>
              <div class="overflow-hidden rounded">
                <img
                  :src="product4"
                  alt="Product 4"
                  class="w-full h-32 sm:h-36 lg:h-40 object-fill"
                />
              </div>
              <div class="overflow-hidden rounded">
                <img
                  :src="product5"
                  alt="Product 5"
                  class="w-full h-32 sm:h-36 lg:h-40 object-fill"
                />
              </div>
              <div class="overflow-hidden rounded">
                <img
                  :src="product6"
                  alt="Product 6"
                  class="w-full h-32 sm:h-36 lg:h-40 object-fill"
                />
              </div>
            </div>
          </div>
          <!-- 右侧优势 -->
          <div class="lg:col-span-4">
            <div class="space-y-3 sm:space-y-4">
              <div
                v-for="(item, index) in features"
                :key="index"
                class="flex items-start gap-3 p-2 rounded-lg"
              >
                <div
                  class="w-8 h-8 rounded-full bg-white border-2 border-[#2f5c45] flex items-center justify-center flex-shrink-0 mt-1 shadow-sm"
                >
                  <img :src="item.icon" :alt="item.title" class="w-5 h-5" />
                </div>
                <div>
                  <h4 class="font-bold text-gray-800 text-xs mb-1">
                    {{ item.title }}
                  </h4>
                  <p class="text-gray-600 text-xs leading-relaxed">{{ item.desc }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const router = useRouter()

// 导航到联系页面
const navigateToContact = () => {
  router.push('/contact')
}

// 导入图片资源
import certIcon from '@/assets/about/材料认证.png'
import degradableIcon from '@/assets/about/可降解材料.png'
import globalIcon from '@/assets/about/业务覆盖全球.png'
import productionIcon from '@/assets/about/高效生产力.png'
import inspectionIcon from '@/assets/about/支持产品出口检测.png'
import cooperationIcon from '@/assets/about/合作共赢-53a028.png'

// 导入品牌图标
import brand1 from '@/assets/about/品牌图标/1.jpg'
import brand2 from '@/assets/about/品牌图标/2.jpg'
import brand3 from '@/assets/about/品牌图标/3.jpg'
import brand4 from '@/assets/about/品牌图标/4.jpg'
import brand5 from '@/assets/about/品牌图标/5.jpg'
import brand6 from '@/assets/about/品牌图标/6.jpg'
import brand7 from '@/assets/about/品牌图标/7.jpg'
import brand8 from '@/assets/about/品牌图标/8.jpg'
import brand9 from '@/assets/about/品牌图标/9.jpg'
import brand10 from '@/assets/about/品牌图标/10.jpg'

// 导入底部图
import product1 from '@/assets/about/底部图/1.png'
import product2 from '@/assets/about/底部图/2.png'
import product3 from '@/assets/about/底部图/3.png'
import product4 from '@/assets/about/底部图/4.png'
import product5 from '@/assets/about/底部图/5.png'
import product6 from '@/assets/about/底部图/6.png'


const { t } = useI18n()

const features = computed(() => [
    {
      icon: certIcon,
      title: t('about.center.features.certification.title'),
      desc: t('about.center.features.certification.desc')
    },
    {
      icon: degradableIcon,
      title: t('about.center.features.degradable.title'),
      desc: t('about.center.features.degradable.desc')
    },
    {
      icon: globalIcon,
      title: t('about.center.features.global.title'),
      desc: t('about.center.features.global.desc')
    },
    {
      icon: productionIcon,
      title: t('about.center.features.production.title'),
      desc: t('about.center.features.production.desc')
    },
    {
      icon: inspectionIcon,
      title: t('about.center.features.inspection.title'),
      desc: t('about.center.features.inspection.desc')
    }
  ])
</script>
<style scoped>
  .container {
    min-height: 1024px;
  }
</style>
